import { useIntl } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { messages } from './messages';
import styles from './styles.module.less';

export const ProductColumn = ({ openProductDetails, data }) => {
  const intl = useIntl();
  return (
    <div className={styles['product-info']}>
      <div className={styles['product-image']}>
        {data.thumbnailUrl ? (
          <img alt={data.name} className={styles['image-placeholder']} src={data.thumbnailUrl} />
        ) : (
          <span className={styles['no-image-placeholder']} />
        )}
      </div>
      <div>
        <Button className={styles['product-name']} onClick={() => openProductDetails(data.productId)} theme={THEME_CONSTANTS.link}>
          {data.name}
        </Button>
        <div className={styles['product-sku']}>{intl.formatMessage(messages.sku, { sku: data.sku })}</div>
      </div>
    </div>
  );
};
